import React, { useEffect } from 'react';
import { Box, useResponsive } from '@common-fe/common-fe';

import useHighlightedPaymentMethodStore from '@/modules/user/components/ManageProfile/components/ReimbursementOptions/stores/useHighlightedPaymentMethod.store';

import PaymentMethodsList from './components/PaymentMethodsList/PaymentMethodsList';
import ReimbursementOptionsHeader from './components/ReimbursementOptionsHeader/ReimbursementOptionsHeader';

interface Props {
  isFetching: boolean;
  refetchPaymentMethods: () => void;
  hasAllowedPaymentMethods?: boolean;
}

const ReimbursementOptions: React.FC<Props> = ({
  isFetching,
  refetchPaymentMethods,
  hasAllowedPaymentMethods,
}) => {
  const { reset } = useHighlightedPaymentMethodStore();
  const { isMobile } = useResponsive();
  useEffect(() => {
    return () => {
      reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box round="moduleRound" pad={isMobile ? 'spacing16' : 'spacing24'} background="module">
      <ReimbursementOptionsHeader hasAllowedPaymentMethods={hasAllowedPaymentMethods} />
      <PaymentMethodsList isFetching={isFetching} refetchPaymentMethods={refetchPaymentMethods} />
    </Box>
  );
};

export default ReimbursementOptions;
